import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { isPortalLang, translations } from "../utils/i18n";

const STORAGE_KEY = "fowebPortalLang";
const LanguageContext = createContext(null);

function readLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isPortalLang(stored)) return stored;
  } catch {
    /* ignore */
  }
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(readLang);

  useEffect(() => {
    document.documentElement.lang = lang === "cn" ? "zh-CN" : "en";
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  const value = useMemo(() => {
    function setLang(next) {
      if (isPortalLang(next)) setLangState(next);
    }
    return {
      lang,
      setLang,
      t: translations[lang] || translations.en,
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
